import { getAppConfig } from './app-config';

const SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80">' +
  '<text x="40" y="40" text-anchor="middle" dominant-baseline="middle" ' +
  'font-family="monospace" font-size="12" font-weight="bold" ' +
  'letter-spacing="4" fill="rgb(42,38,34)" fill-opacity="0.15" ' +
  'transform="rotate(-45 40 40)">DEV</text></svg>';

const DATA_URL = 'url("data:image/svg+xml,' + encodeURIComponent(SVG) + '")';

let _sheet: CSSStyleSheet | null = null;

function _getSheet(): CSSStyleSheet {
  if (!_sheet) {
    _sheet = new CSSStyleSheet();
    _sheet.replaceSync(`.top-bar { background-image: ${DATA_URL}; background-size: 80px 80px; }`);
  }
  return _sheet;
}

export async function applyDevWatermark(root: ShadowRoot): Promise<void> {
  const { environment } = await getAppConfig();
  if (environment !== 'dev') return;
  const sheet = _getSheet();
  if (!root.adoptedStyleSheets.includes(sheet)) {
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
  }
}